module.exports = __webpack_public_path__ + "static/media/bgloop.9ab3cd2d.mp4";